import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { useEffect } from 'react'
import Layout from './components/Layout'
import ErrorBoundary from './components/ErrorBoundary'
import ProtectedRoute from './components/ProtectedRoute'
import Home from './pages/Home'
import Inbox from './pages/Inbox'
import Projects from './pages/Projects'
import SettingsUsers from './pages/SettingsUsers'
import SettingsSecurity from './pages/SettingsSecurity'
import ProjectDetails from './pages/ProjectDetails'
import AssetDetails from './pages/AssetDetails'
import ScanDetails from './pages/ScanDetails'
import Profile from './pages/Profile'
import Login from './pages/Login'
import Signup from './pages/Signup'
import ForgotPassword from './pages/ForgotPassword'
import ResetPassword from './pages/ResetPassword'
import Tenants from './pages/Tenants'
import Users from './pages/Users'
import Assets from './pages/Assets'
import Roles from './pages/Roles'
import Permissions from './pages/Permissions'
import Notifications from './pages/Notifications'
import ActivityLogs from './pages/ActivityLogs'
import Blogs from './pages/Blogs'
import BlogForm from './pages/BlogForm'
import { initializeAuth } from './stores/authStore'
import { useThemeStore } from './stores/themeStore'

function App() {
  const { isDarkMode, toggleTheme, initializeTheme } = useThemeStore()

  useEffect(() => {
    // Initialize authentication state
    initializeAuth()

    // Initialize theme
    initializeTheme()
  }, [initializeTheme])

  return (
    <ErrorBoundary>
      <Router>
        <div className={`min-h-screen ${isDarkMode ? 'dark' : ''}`}>
          <Routes>
            {/* Public routes */}
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />

            {/* Main dashboard and protected routes */}
            <Route
              path="/*"
              element={
                <ProtectedRoute>
                  <Layout toggleTheme={toggleTheme} isDarkMode={isDarkMode}>
                    <Routes>
                      <Route path="/" element={<Home />} />
                      <Route path="/inbox" element={<Inbox />} />
                      <Route path="/projects" element={<Projects />} />
                      <Route
                        path="/projects/:projectId"
                        element={<ProjectDetails />}
                      />
                      <Route
                        path="/projects/:projectId/assets/:assetId"
                        element={<AssetDetails />}
                      />
                      <Route
                        path="/projects/:projectId/assets/:assetId/scans/:scanId"
                        element={<ScanDetails />}
                      />
                      <Route path="/tenants" element={<Tenants />} />
                      <Route
                        path="/tenants/:tenantId/users"
                        element={<Users />}
                      />
                      <Route path="/assets" element={<Assets />} />
                      <Route path="/roles" element={<Roles />} />
                      <Route path="/permissions" element={<Permissions />} />
                      <Route
                        path="/settings/users"
                        element={<SettingsUsers />}
                      />
                      <Route
                        path="/settings/security"
                        element={<SettingsSecurity />}
                      />
                      <Route
                        path="/notifications"
                        element={
                          <ProtectedRoute requiredRole="ADMIN">
                            <Notifications />
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path="/activity-logs"
                        element={
                          <ProtectedRoute requiredRole="ADMIN">
                            <ActivityLogs />
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path="/blogs"
                        element={
                          <ProtectedRoute requiredRole="ADMIN">
                            <Blogs />
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path="/blogs/create"
                        element={
                          <ProtectedRoute requiredRole="ADMIN">
                            <BlogForm />
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path="/blogs/edit/:id"
                        element={
                          <ProtectedRoute requiredRole="ADMIN">
                            <BlogForm />
                          </ProtectedRoute>
                        }
                      />
                      <Route path="/profile" element={<Profile />} />
                    </Routes>
                  </Layout>
                </ProtectedRoute>
              }
            />
          </Routes>
        </div>
      </Router>
    </ErrorBoundary>
  )
}

export default App
